import React from "react";
import { Image, LinkBox, Box, Section, Text } from "@quarkly/widgets";
import { Override } from "@quarkly/components";

import image_sponcollab_su from "../assets/logos_sponsors_collabs/sustainsu-1.png";
import image_sponcollab_esw from "../assets/logos_sponsors_collabs/esw.png";
import image_sponcollab_sinkunia from "../assets/logos_sponsors_collabs/sinkunia.png";
import image_sponcollab_perma from "../assets/logos_sponsors_collabs/permacultureclub.jpeg";
import image_sponcollab_wire from "../assets/logos_sponsors_collabs/wire.png";
import image_sponcollab_ess from "../assets/logos_sponsors_collabs/ess.png";

const Collaborators = () => (
  <>
    <Section padding="60px 0 40px 0" quarkly-title="Section_Collabs_Title">
      <Box
        md-width="100%"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-width="1px"
        empty-border-style="solid"
        empty-border-color="LightGray"
        width="100%"
        display="flex"
        align-self="auto"
        flex="1 1 0%"
        align-items="center"
        justify-content="center"
        flex-direction="column"
        flex-wrap="no-wrap"
      >
        <Text
          margin="0px 0px 40px 0px"
          color="--light"
          font="--headline2"
          lg-font="normal 500 32px/1.2 --fontFamily-googleAlegreyaSans, sans-serif"
          md-margin="0px 0px 16px 0px"
        >
          Our Collaborators and Friends
        </Text>
        <Text
          color="--light"
          font="--base"
          lg-font='normal 400 16px/1.5 "Varta", sans-serif'
          margin="0px 0px 0px 0px"
          text-align="left"
        >
          Organizations that we like and have worked with!
        </Text>
      </Box>
    </Section>
    <Section
      padding="40px 0 40px 0"
      md-padding="20px 0 12px 0"
      quarkly-title="Section_Collabs_Content1"
    >
      <Override
        slot="SectionContent"
        flex-direction="row"
        md-flex-wrap="wrap"
      />
      <Box
        empty-border-width="1px"
        empty-border-style="solid"
        width="50%"
        md-width="100%"
        md-padding="0px 0px 0px 0px"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-color="LightGray"
        padding="0px 0px 0px 20px"
      >
        <LinkBox
          target="_blank"
          href="https://www2.su.ualberta.ca/services/sustainsu/projects/garden/"
        >
          <Image
            src={image_sponcollab_su}
            max-height="400px"
            width="100%"
            object-fit="cover"
            lg-max-height="400px"
            // height="100%"
            srcSet={`${image_sponcollab_su} 500w, ${image_sponcollab_su} 800w, ${image_sponcollab_su} 1080w, ${image_sponcollab_su} 1600w, ${image_sponcollab_su} 2000w, ${image_sponcollab_su} 2600w, ${image_sponcollab_su} 3200w`}
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
          <Text
            margin="32px 0px 16px 0px"
            font="--lead"
            color="--green"
            lg-font='normal 600 20px/1.5 "Varta", sans-serif'
            md-margin="12px 0px 16px 0px"
            sm-margin="24px 0px 16px 0px"
            text-align="center"
          >
            Sustain, at Students' Union
          </Text>
        </LinkBox>
      </Box>
      <Box
        empty-border-width="1px"
        empty-border-style="solid"
        width="50%"
        md-width="100%"
        md-padding="0px 0px 0px 0px"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-color="LightGray"
        padding="0px 0px 0px 20px"
      >
        <LinkBox target="_blank" href="https://www.eswualberta.com/">
          <Image
            src={image_sponcollab_esw}
            max-height="400px"
            width="85%"
            object-fit="cover"
            lg-max-height="230px"
            height="100%"
            srcSet={`${image_sponcollab_esw} 500w, ${image_sponcollab_esw} 800w, ${image_sponcollab_esw} 1080w, ${image_sponcollab_esw} 1600w, ${image_sponcollab_esw} 2000w, ${image_sponcollab_esw} 2600w, ${image_sponcollab_esw} 3200w`}
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
          <Text
            margin="32px 0px 16px 0px"
            font="--lead"
            color="--green"
            lg-font='normal 600 20px/1.5 "Varta", sans-serif'
            md-margin="12px 0px 16px 0px"
            sm-margin="24px 0px 16px 0px"
            text-align="center"
          >
            Engineers for Sustainable World
          </Text>
        </LinkBox>
      </Box>
      <Box
        empty-border-width="1px"
        empty-border-style="solid"
        width="50%"
        md-width="100%"
        md-padding="0px 0px 0px 0px"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-color="LightGray"
        padding="0px 0px 0px 20px"
      >
        <LinkBox target="_blank" href="https://www.sinkuniacommunity.org/">
          <Image
            src={image_sponcollab_sinkunia}
            max-height="400px"
            width="85%"
            object-fit="cover"
            lg-max-height="230px"
            overflow="visible"
            height="100%"
            margin="125px 0px 0px 0px"
            srcSet={`${image_sponcollab_sinkunia} 500w, ${image_sponcollab_sinkunia} 800w, ${image_sponcollab_sinkunia} 1080w, ${image_sponcollab_sinkunia} 1600w, ${image_sponcollab_sinkunia} 2000w, ${image_sponcollab_sinkunia} 2600w, ${image_sponcollab_sinkunia} 3200w`}
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
          <Text
            margin="32px 0px 16px 0px"
            font="--lead"
            color="--green"
            lg-font='normal 600 20px/1.5 "Varta", sans-serif'
            md-margin="12px 0px 16px 0px"
            sm-margin="24px 0px 16px 0px"
            text-align="center"
          >
            Sinkunia Community Organization
          </Text>
        </LinkBox>
      </Box>
    </Section>
    <Section
      padding="40px 0 40px 0"
      md-padding="20px 0 12px 0"
      quarkly-title="Section_Collabs_Content1"
    >
      <Override
        slot="SectionContent"
        flex-direction="row"
        md-flex-wrap="wrap"
      />
      <Box
        empty-border-width="1px"
        empty-border-style="solid"
        width="50%"
        md-width="100%"
        md-padding="0px 0px 0px 0px"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-color="LightGray"
        padding="0px 0px 0px 20px"
      >
        <LinkBox
          target="_blank"
          href="https://www.essualberta.ca/studentgroups/permaculture"
        >
          <Image
            src={image_sponcollab_perma}
            max-height="400px"
            // width="85%"
            object-fit="cover"
            lg-max-height="400px"
            height="100%"
            srcSet={`${image_sponcollab_perma} 500w, ${image_sponcollab_perma} 800w, ${image_sponcollab_perma} 1080w, ${image_sponcollab_perma} 1600w, ${image_sponcollab_perma} 2000w, ${image_sponcollab_perma} 2600w, ${image_sponcollab_perma} 3200w`}
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
          <Text
            margin="32px 0px 16px 0px"
            font="--lead"
            color="--green"
            lg-font='normal 600 20px/1.5 "Varta", sans-serif'
            md-margin="12px 0px 16px 0px"
            sm-margin="24px 0px 16px 0px"
            text-align="center"
          >
            Permaculture Club
          </Text>
        </LinkBox>
      </Box>
      <Box
        empty-border-width="1px"
        empty-border-style="solid"
        width="50%"
        md-width="100%"
        md-padding="0px 0px 0px 0px"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-color="LightGray"
        padding="0px 0px 0px 20px"
      >
        <LinkBox
          target="_blank"
          href="https://womeninrenewableenergy.ca/wire-chapters/wire-canada-central"
        >
          <Image
            src={image_sponcollab_wire}
            max-height="350px"
            // width="100%"
            object-fit="cover"
            lg-max-height="200px"
            height="85%"
            srcSet={`${image_sponcollab_wire} 500w, ${image_sponcollab_wire} 800w, ${image_sponcollab_wire} 1080w, ${image_sponcollab_wire} 1600w, ${image_sponcollab_wire} 2000w, ${image_sponcollab_wire} 2600w, ${image_sponcollab_wire} 3200w`}
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
          <Text
            margin="32px 0px 16px 0px"
            font="--lead"
            color="--green"
            lg-font='normal 600 20px/1.5 "Varta", sans-serif'
            md-margin="12px 0px 16px 0px"
            sm-margin="24px 0px 16px 0px"
            text-align="center"
          >
            Women in Renewable Energy
          </Text>
        </LinkBox>
      </Box>
      <Box
        empty-border-width="0px"
        empty-border-style="solid"
        width="50%"
        md-width="100%"
        md-padding="0px 0px 0px 0px"
        empty-min-width="64px"
        empty-min-height="64px"
        empty-border-color="LightGray"
        padding="0px 0px 0px 20px"
      >
        <LinkBox target="_blank" href="https://www.essualberta.ca/">
          <Image
            src={image_sponcollab_ess}
            max-height="400px"
            width="85%"
            object-fit="cover"
            lg-max-height="230px"
            overflow="visible"
            height="100%"
            margin="125px 0px 0px 0px"
            srcSet={`${image_sponcollab_ess} 500w, ${image_sponcollab_ess} 800w, ${image_sponcollab_ess} 1080w, ${image_sponcollab_ess} 1600w, ${image_sponcollab_ess} 2000w, ${image_sponcollab_ess} 2600w, ${image_sponcollab_ess} 3200w`}
            sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,100vw"
          />
          <Text
            margin="32px 0px 16px 0px"
            font="--lead"
            color="--green"
            lg-font='normal 600 20px/1.5 "Varta", sans-serif'
            md-margin="12px 0px 16px 0px"
            sm-margin="24px 0px 16px 0px"
            text-align="center"
          >
            Engineering Students' Society
          </Text>
        </LinkBox>
      </Box>
    </Section>
  </>
);

export default Collaborators;
